// --- UI Components
import { ClickableCellRenderer } from '../../../../../components/AGGrid/cell-renderers/clickable';
import { ProductActionButtonsRenderer } from '../../../../../components/AGGrid/cell-renderers/product-multi-clickable';
import {CustomHeader} from "../../../../../components/AGGrid/cell-renderers/custom-header";

export const sid = {
    field: 'id',
    headerName: 'SID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'products',
    }
};

export const productId = {
    field: 'productId',
    headerName: 'Product ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productId',
        page: 'products',
    }
};

export const uuid = {
    field: 'guid',
    headerName: 'UUID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'guid',
        page: 'products',
    }
};

export const releaseDate = {
    field: 'releaseDate',
    headerName: 'Release Date',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'releaseDate',
        page: 'products',
    }
};

export const title = {
    field: 'productTitle',
    headerName: 'Title',
    tooltipField: 'productTitle',
    flex: 5,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productTitle',
        page: 'products',
    }
};

export const type = {
    field: 'productClass',
    headerName: 'Type',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productClass',
        page: 'products',
    }
};

export const runTime = {
    field: 'runTime',
    headerName: 'Run Time',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'runTime',
        page: 'products',
    }
};

export const clearanceMemo = (
    onOpenLegalStatusModal,
    onOpenContractualPartiesModal,
    onOpenCopyToModal,
    onOpenVersionModal,
    onOpenDeleteModal,
    onOpenCreateModal,
    onOpenEditModal,
    onOpenViewModal,
) => ({
    headerName: 'Clearance Memo',
    valueGetter: (data) => {
        return (
            data?.data.hasClearanceMemo &&
            legalStatuses.find((status) => status.value === data?.data.legalStatusId).label
        );
    },
    cellRenderer: ProductActionButtonsRenderer(
        onOpenLegalStatusModal,
        onOpenContractualPartiesModal,
        onOpenCopyToModal,
        onOpenVersionModal,
        onOpenDeleteModal,
        onOpenCreateModal,
        onOpenEditModal,
        onOpenViewModal,
    ),
    flex: 6,
});

export const comments = (onOpenCommentsModal) => ({
    headerName: 'Comments',
    valueGetter: (data) => {
        return data?.data?.productComments ? data?.data.productComments.length : 0;
    },
    cellRenderer: ClickableCellRenderer(onOpenCommentsModal, 'fa-comment'),
    flex: 2,

});

export const rlLoadStatus = {
    field: 'loadStatus',
    headerName: 'RL Load Status',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'loadStatus',
        page: 'products',
    }
};

export const details = (
    onOpenDetailsDrawer,
) => ({
    headerName: 'Details',
    valueGetter: (data) => {
        return 'DETAILS';
    },
    tooltipField: '',
    cellRenderer: ClickableCellRenderer(onOpenDetailsDrawer, 'fa-eye'),
    flex: 2,
});

const legalStatuses = [
    { label: 'CONFIRMED', value: 1 },
    { label: 'DRAFT', value: 2 },
    { label: 'PENDING', value: 3 },
    { label: 'PENDING WITH FEATURE CAVEAT', value: 4 },
    { label: 'PRELIMINARY', value: 5 },
    { label: 'PROCESSING', value: 7 },
];

